import * as types from '../../mutation-types';
import dbConnector from '../../api/dbConnector';
import Vue from 'vue'

const state = {
  timetables: [],
  timeObjRows: [],
  formattedTimetableObj: {},
}

const getters = {
  getFormattedTimetableObj: state => state.formattedTimetableObj,
  getTimeObjRows: state => state.timeObjRows,
  getTimetables: state => state.timetables
}

const actions = {
  getAllTimetables ({commit}, cb){
    dbConnector.getTimeTables((timetables,timeObj) => {
      commit(types.RECEIVE_TIME_TABLES, {timetables,timeObj})
      if (cb) cb()
    })
  }
}

const mutations = {
  [types.RECEIVE_TIME_TABLES] (state, {timetables,timeObj}) {
    state.timetables = timetables
    state.timeObjRows = timeObj
    timetables.reverse().forEach(timetable => {
      let entryListTimetable = returnTimeObjByRefTimetableId(timetable.id)
      if (entryListTimetable.length > 0) {
        Vue.set(state.formattedTimetableObj, timetable.id, entryListTimetable)
        let timeObjWrapper = createTimeObjWrapperFromRows(entryListTimetable)
        createTimeObjFromRow(timeObjWrapper, state.formattedTimetableObj[timetable.id])
        Vue.set(state.formattedTimetableObj, timetable.id, timeObjWrapper)
      } else {
        Vue.set(state.formattedTimetableObj, timetable.id, {})
      }
    })
  }
}
function returnTimeObjByRefTimetableId(id) {
  return state.timeObjRows.filter((item) => parseInt(item.ref_timetable) === parseInt(id))
}
function  createTimeObjWrapperFromRows (timeObjArr) {
  let formattedTimeObj = {}
  timeObjArr.forEach(timeObj => {
    createTimeObjWrapperFromRow(timeObj, formattedTimeObj)
  })
  return formattedTimeObj
}
function createTimeObjWrapperFromRow(timeObj, formattedObj) {
  if (!formattedObj[timeObj.day_index]) {
    Vue.set(formattedObj, timeObj.day_index, {})
    Vue.set(formattedObj[timeObj.day_index], timeObj.time_index, {})
    Vue.set(formattedObj[timeObj.day_index][timeObj.time_index], timeObj.rink, {})
  } else if (!formattedObj[timeObj.day_index][timeObj.time_index]) {
    Vue.set(formattedObj[timeObj.day_index], timeObj.time_index, {})
    Vue.set(formattedObj[timeObj.day_index][timeObj.time_index], timeObj.rink, {})
  } else if (formattedObj[timeObj.day_index][timeObj.time_index][timeObj.rink]) {
    Vue.set(formattedObj[timeObj.day_index][timeObj.time_index], timeObj.rink, {})
  }
}
function createTimeObjFromRow (timeObjWrapper, rows) {
  rows.forEach(row => {
    Vue.set(timeObjWrapper[row.day_index][row.time_index], row.rink, {
      timeStart: row.timeStart,
      timeEnd: row.timeEnd,
      id: row.id,
      category: typeof row.category === 'string' && row.category.length === 23 ? JSON.parse(row.category) : row.category
    })
  })
}

export default {
  state,
  getters,
  actions,
  mutations
}
